// extracted by mini-css-extract-plugin
module.exports = {"container":"e_JG","grayStyle":"e_KG"};